import { Users, Landmark, Plane, LayoutDashboard, Megaphone, MessageSquare, ShoppingBag, UtensilsCrossed, Briefcase, Network, Scale, Building2, Wrench, Radio, Boxes } from "lucide-react";

const ICONS = { Users, Landmark, Plane, LayoutDashboard, Megaphone, MessageSquare, ShoppingBag, UtensilsCrossed, Briefcase, Network, Scale, Building2, Wrench, Radio, Boxes };

export const ProductIcon = ({ name, className = "w-6 h-6" }) => {
  const Icon = ICONS[name] || Boxes;
  return <Icon className={className} />;
};
